import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Button } from './ui/button';

const FinalCTA = () => {
  const handleWhatsAppClick = () => {
    const message = encodeURIComponent("Hi Ukiyo Tours! Let's plan my next holiday.");
    window.open(`https://wa.me/918591732501?text=${message}`, '_blank');
  };

  return (
    <section className="py-24 bg-gradient-to-br from-[#1e3a5f] to-[#2a4d75] relative overflow-hidden">
      {/* Decorative Elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-[#c9a961]/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-[#c9a961]/10 rounded-full blur-3xl"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
        <h2 className="text-4xl md:text-6xl font-bold text-white mb-6">
          Let's Plan Your Next Holiday
        </h2>
        <p className="text-xl md:text-2xl text-white/90 mb-10 leading-relaxed">
          Get the best deals and curated options tailored to your travel style.
        </p>
        <Button 
          onClick={handleWhatsAppClick}
          size="lg"
          className="bg-[#B8964F] hover:bg-[#a67f3a] text-white text-lg px-12 py-7 rounded-xl shadow-2xl hover:shadow-3xl transition-all duration-300 hover:scale-105 group"
        >
          Plan Your Holiday on WhatsApp
          <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform duration-300" size={24} />
        </Button>
      </div>
    </section>
  );
};

export default FinalCTA;
